import {Pipe, PipeTransform} from '@angular/core';
import {MissedOpportunity} from "@services";

@Pipe({
    name: 'missedOpportunity',
    standalone: true
})
export class MissedOpportunityPipe implements PipeTransform {
    transform(value: MissedOpportunity | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case MissedOpportunity.LayerOpportunity: return "Layer Opportunity";
            case MissedOpportunity.PalletOpportunity: return "Pallet Opportunity";

            default: return value;
        }
    }
}
